// extracted by mini-css-extract-plugin
export default {"container":"container__tNr1_W99","message":"message__yFJlJ9_l"};